import { useEffect, useState } from "react";
import { registerServiceWorker } from "../../../utils/pushNotifications";
import s from "../AdminPortal/adminApp.module.css";

export default function PwaUpdateBanner() {
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return undefined;

    registerServiceWorker().then((reg) => {
      if (!reg) return;

      reg.update().catch(() => {});

      if (reg.waiting && navigator.serviceWorker.controller) {
        setPending(true);
      }

      reg.addEventListener("updatefound", () => {
        const worker = reg.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (
            worker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            setPending(true);
          }
        });
      });
    });
  }, []);

  if (!pending) return null;

  const reload = () => {
    navigator.serviceWorker.ready.then((reg) => {
      if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
      window.setTimeout(() => window.location.reload(), 300);
    });
  };

  return (
    <div className={s.updateBanner} role="status">
      <div>
        <strong>Доступна новая версия</strong>
        <p>Обновите приложение, чтобы получить последние изменения</p>
      </div>
      <button type="button" className={s.installBtn} onClick={reload}>
        Обновить
      </button>
    </div>
  );
}
